'use client';

import { c as _c } from "react/compiler-runtime";
import { type MouseEvent, type ReactNode, useState } from 'react';
import MarkdownDescriptionReadMore from '@/app/[locale]/(worlds)/[roomId]/components/MarkdownDescriptionReadMore';
import ExternalLinkConfirmModal from '@/components/ExternalLinkConfirmModal';
const isModifiedClick = (event: MouseEvent) => event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
type MarkdownDescriptionProps = {
  /** Server-rendered `MarkdownDescriptionContent`. */
  content: ReactNode;
};

/** Renders the creator's rich-text description; links open only after a leave-site confirmation. */
function MarkdownDescription(t0) {
  const $ = _c(11);
  const {
    content
  } = t0;
  const [pendingUrl, setPendingUrl] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event => {
      if (isModifiedClick(event) || !(event.target instanceof Element)) {
        return;
      }
      const link = event.target.closest("[data-component=\"markdown-description\"] a[href]");
      if (!link) {
        return;
      }
      event.preventDefault();
      setPendingUrl(link.getAttribute("href"));
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleClick = t1;
  let t2;
  if ($[1] !== content) {
    t2 = <div className="contents" onClick={handleClick}><MarkdownDescriptionReadMore content={content} /></div>;
    $[1] = content;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = pendingUrl ?? "";
  const t4 = pendingUrl !== null;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setPendingUrl(null);
    t6 = () => setPendingUrl(null);
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t3 || $[6] !== t4) {
    t7 = <ExternalLinkConfirmModal url={t3} open={t4} onCancel={t5} onConfirm={t6} />;
    $[5] = t3;
    $[6] = t4;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t2 || $[9] !== t7) {
    t8 = <>{t2}{t7}</>;
    $[8] = t2;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}
export default MarkdownDescription;